export const ileggelseadmin = "ileggelse-admin";
export const stedfortrederDriftsleder = "ileggelse-stedfortreder-driftsleder";

export const skiftlogg = "ileggelse-skiftlogg"; // Tilhører bypatrluljen men skal kun ha tilgång til skiftlogg

export const bypatruljen = {
  saksbehandler: "ileggelse-saksbehandler",
  saksbehandleradmin: "ileggelse-saksbehandler-admin",
  avdelingdirektor: "ileggelse-avdelingsdirektor",
  seksjonssjefStab: "ileggelse-seksjonssjefbypatruljen-plan-forvaltning",
  seksjonssjef: "ileggelse-seksjonssjefbypatruljen",
  driftleder: "ileggelse-driftsleder",
  stedfortrederDriftsleder: stedfortrederDriftsleder,
};

export const juridisk = {
  saksbehandler: "ileggelse-saksbehandler-juridisk",
  ledelse: "ileggelse-ledelse-juridisk",
};

export const innsyn = {
  kemnerkontoret: "ileggelse-kemner",
  seksjonssjefVaktsentralen: "ileggelse-seksjonsjef-vaktsentral",
  regnskap: "ileggelse-regnskap",
  serviceavdeling: "ileggelse-innsyn-service",
  vaktsentralen: "ileggelse-innsyn-vaktsentralen",
};

export const bypatruljenAll = Object.values(bypatruljen);

export const juridiskAll = Object.values(juridisk);

export const bypatruljenAndJuridiskAll = bypatruljenAll.concat(juridiskAll);

export const innsynAll = Object.values(innsyn);
